// Mock data for Cheater Beaters website

export const shows = [
  {
    id: 1,
    title: "Caught Red Handed: Season 3 Premiere",
    thumbnail: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=600&h=400&fit=crop",
    youtubeId: "dQw4w9WgXcQ",
    category: "New Episode",
    views: "1.2M",
    duration: "45:00"
  },
  {
    id: 2,
    title: "The Ultimate Betrayal - Special Episode",
    thumbnail: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=600&h=400&fit=crop",
    youtubeId: "dQw4w9WgXcQ",
    category: "Special",
    views: "890K",
    duration: "52:00"
  },
  {
    id: 3,
    title: "Double Life Exposed: Part 1",
    thumbnail: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=600&h=400&fit=crop",
    youtubeId: "dQw4w9WgXcQ",
    category: "Drama",
    views: "2.1M",
    duration: "38:00"
  },
  {
    id: 4,
    title: "When Trust Is Broken",
    thumbnail: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=600&h=400&fit=crop",
    youtubeId: "dQw4w9WgXcQ",
    category: "Documentary",
    views: "567K",
    duration: "41:00"
  },
  {
    id: 5,
    title: "Secret Affairs: The Investigation",
    thumbnail: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=600&h=400&fit=crop",
    youtubeId: "dQw4w9WgXcQ",
    category: "Investigation",
    views: "1.5M",
    duration: "48:00"
  },
  {
    id: 6,
    title: "The Truth Comes Out",
    thumbnail: "https://images.unsplash.com/photo-1524712245354-2c4e5e7121c0?w=600&h=400&fit=crop",
    youtubeId: "dQw4w9WgXcQ",
    category: "Exclusive",
    views: "3.2M",
    duration: "55:00"
  }
];

export const featuredShow = {
  id: 0,
  title: "Cheater Beaters: New Season Premiere",
  description: "Get a front row seat to all the madness, drama, and nonstop entertainment. Watch as our team uncovers the truth and exposes the lies. REAL. RAW. UNFILTERED.",
  thumbnail: "https://images.unsplash.com/photo-1594909122845-11baa439b7bf?w=1200&h=600&fit=crop",
  youtubeId: "dQw4w9WgXcQ",
  category: "Season Premiere",
  releaseDate: "October 2025"
};

export const podcastInfo = {
  title: "Dear Cheater Beaters",
  description: "Dear Cheater Beaters is a companion podcast to the TV show that takes you deeper into the lives of characters from the show and beyond. Our hosts talk to interesting people who have cheated and been cheated on as they recount their wild stories.",
  callToAction: "If you are the Cheater, and want to appear on the podcast. Just leave us your Cheating story and we might feature it on our 'Oh No You Didn't' section of the podcast. Tell us how you got caught and the situation and maybe we will give you a call."
};

export const storyTypes = [
  "I was cheated on",
  "I am the cheater",
  "I witnessed cheating",
  "Other situation"
];

export const recentStories = [
  {
    id: 1,
    title: "Found Out After 10 Years",
    excerpt: "After a decade of marriage, I discovered text messages that changed everything...",
    author: "Anonymous",
    date: "July 12, 2025",
    views: 15420
  },
  {
    id: 2,
    title: "The Double Life",
    excerpt: "He had two families in different states. Neither knew about the other...",
    author: "Sarah M.",
    date: "July 10, 2025",
    views: 28930
  },
  {
    id: 3,
    title: "Caught at the Airport",
    excerpt: "My best friend spotted my husband boarding a flight with another woman...",
    author: "Anonymous",
    date: "July 8, 2025",
    views: 34210
  },
  {
    id: 4,
    title: "The Wedding Crasher",
    excerpt: "His ex showed up at our wedding with evidence I couldn't ignore...",
    author: "Jennifer K.",
    date: "July 5, 2025",
    views: 52100
  }
];

export const navLinks = [
  { name: "Home", href: "/" },
  { name: "Shows", href: "/shows" },
  { name: "Submit Story", href: "/submit" },
  { name: "Podcast", href: "/podcast" },
  { name: "About", href: "/about" }
];
